import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';

@Component({
  selector: 'ta-livAllertaLegenda',
  styleUrls: ['./livAllertaLegenda.component.scss'],
  templateUrl: './livAllertaLegenda.component.html',
})

export class LivAllertaLegenda implements OnInit, OnDestroy{

  constructor(private modalService: NgbModal, private _sanitizer: DomSanitizer ) { }

  precipitazioni_verde: string = "Assenza o bassa probabilità a livello locale di fenomeni significativi prevedibili.";
  precipitazioni_gialla: string = "Occasionale pericolo: fenomeni ed effetti locali.";
  precipitazioni_arancione: string = "Pericolo: fenomeni ed effetti diffusi";
  precipitazioni_rossa: string = "Grave pericolo: fenomeni ed effetti ingenti ed estesi";
  
  precipitazioniVerdeBreve: string = (this.precipitazioni_verde.length > 200) ? this.precipitazioni_verde.substring(0, 200)+'...' : this.precipitazioni_verde;
  precipitazioniGiallaBreve: string = (this.precipitazioni_gialla.length > 200) ? this.precipitazioni_gialla.substring(0, 200)+'...' : this.precipitazioni_gialla;
  precipitazioniArancioneBreve: string = (this.precipitazioni_arancione.length > 200) ? this.precipitazioni_arancione.substring(0, 200)+'...' : this.precipitazioni_arancione;
  precipitazioniRossaBreve: string = (this.precipitazioni_rossa.length > 200) ? this.precipitazioni_rossa.substring(0, 200)+'...' : this.precipitazioni_rossa;

  temporali_verde: string = "Assenza o bassa probabilità a livello locale di fenomeni significativi prevedibili.";
  temporali_gialla: string = "Occasionale pericolo: fenomeni puntuali anche intensi e repentini.";
  temporali_arancione: string = "Pericolo: massima gravità per fenomeni puntuali anche molto intensi, repentini e persistenti.";
  temporali_rossa: string = "N.B.: Il codice rosso non è previsto per i temporali.";
  
  temporaliVerdeBreve: string = (this.temporali_verde.length > 200) ? this.temporali_verde.substring(0, 200)+'...' : this.temporali_verde;
  temporaliGiallaBreve: string = (this.temporali_gialla.length > 200) ? this.temporali_gialla.substring(0, 200)+'...' : this.temporali_gialla;
  temporaliArancioneBreve: string = (this.temporali_arancione.length > 200) ? this.temporali_arancione.substring(0, 200)+'...' : this.temporali_arancione;
  temporaliRossaBreve: string = (this.temporali_rossa.length > 200) ? this.temporali_rossa.substring(0, 200)+'...' : this.temporali_rossa;

/*vento_verde: string = "Vento Verde fenomeni ed effetti ingenti ed estesi.";
  vento_gialla: string = "Vento Gialla fenomeni ed effetti ingenti ed estesi.";
  vento_arancione: string = "Vento Arancione fenomeni ed effetti ingenti ed estesi.";
  vento_rossa: string = "Vento Rossa fenomeni ed effetti ingenti ed estesi.";
 */  
  mare_verde: string = "Assenza o bassa probabilità a livello locale di fenomeni significativi prevedibili.";
  mare_gialla: string = "Incremento locale dei livelli idrometrici dei corsi d’acqua maggiori, generalmente contenuti all’interno dell’alveo.";
  mare_arancione: string = "Significativi innalzamenti dei livelli  idrometrici dei corsi d’acqua maggiori con fenomeni di inondazione delle aree limitrofe e delle zone golenali, interessamento degli argini. Fenomeni di erosione delle sponde, trasporto solido e divagazione dell’alveo. Occlusioni, parziali o totali, delle luci dei ponti dei corsi d’acqua maggiori.";
  mare_rossa: string = "Piene fluviali dei corsi d’acqua maggiori con estesi fenomeni di inondazione anche di aree distanti dal fiume, diffusi fenomeni di erosione delle sponde, trasporto solido e divagazione dell’alveo. Fenomeni di tracimazione, sifonamento o rottura degli argini, sormonto dei ponti e altre opere di attraversamento, nonché salti di meandro. Occlusioni, parziali o totali, delle luci dei ponti dei corsi d’acqua maggiori.";
  
  mareVerdeBreve: string = (this.mare_verde.length > 200) ? this.mare_verde.substring(0, 200)+'...' : this.mare_verde;
  mareGiallaBreve: string = (this.mare_gialla.length > 200) ? this.mare_gialla.substring(0, 200)+'...' : this.mare_gialla;
  mareArancioneBreve: string = (this.mare_arancione.length > 200) ? this.mare_arancione.substring(0, 200)+'...' : this.mare_arancione;
  mareRossaBreve: string = (this.mare_rossa.length > 200) ? this.mare_rossa.substring(0, 200)+'...' : this.mare_rossa;

/*neve_verde: string = "Neve Verde fenomeni ed effetti ingenti ed estesi.";
  neve_gialla: string = "Neve Gialla fenomeni ed effetti ingenti ed estesi.";
  neve_arancione: string = "Neve Arancione fenomeni ed effetti ingenti ed estesi.";
  neve_rossa: string = "Neve Rossa fenomeni ed effetti ingenti ed estesi.";
 */  
/*anomalia_temperature_verde: string = "Anomalia Temperature Verde fenomeni ed effetti ingenti ed estesi.";
  anomalia_temperature_gialla: string = "Anomalia Temperature Gialla fenomeni ed effetti ingenti ed estesi.";
  anomalia_temperature_arancione: string = "Anomalia Temperature Arancione fenomeni ed effetti ingenti ed estesi.";
  anomalia_temperature_rossa: string = "Anomalia Temperature Rossa fenomeni ed effetti ingenti ed estesi.";
 */




  ngOnInit() {

  }

  ngOnDestroy() {
    
  }

  getWindowWidth() { 
    if (window.innerWidth > 1199) return true;
    else
    return false; 
  }
  
  // openModal(livelloHtml:any, titoloLivello,) {
    
  //   const activeModal = this.modalService.open(ModalComponent, { size: 'lg', container: 'nb-layout' });

  //   activeModal.componentInstance.modalHeader = 'Large Modal';
  //   activeModal.componentInstance.title = titoloLivello;
  //   var strHTML = 
  //   `<div style="font-family: roboto;">
  //     <p style=" text-align: justify; margin: auto; padding: 20px;">
  //     ` + livelloHtml + `
  //     </p>
  //   </div>`;

  //   activeModal.componentInstance.htmlToRender = strHTML; //this._sanitizer.bypassSecurityTrustHtml(strHTML);
  //   activeModal.componentInstance.activeModal = activeModal;

  // }

}